import React from "react"
import News from "../../blocks/news"
import { graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "krapukhin_transfers_to_riga" }) {
    ...NewsInfo
  }
}`

export default class NewsText extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Станислав Крапухин, российский нападающий ФК Зенит из Санкт-Петербурга, подписал контракт с чемпионом Латвии ФК Рига.</p>
        </div>
      </div>
    )
  }
}